import { meetingBodyTypeValueLabels, meetingStatusValueLabels, seatCampaignStatusValueLabels, seatTypeValueLabels, } from './value-labels.js';
import { departmentLink, meetingBodyLink, meetingLink, userLink } from './links.js';
export const meetingBodyJoinDimensions = {
    'meeting_bodies.is_active': { label: 'Meeting Body Is Active', type: 'boolean' },
    'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
    'meeting_bodies.type': {
        label: 'Meeting Body Type',
        type: 'string',
        valueLabels: meetingBodyTypeValueLabels,
    },
};
export const seatJoinDimensions = {
    'meeting_body_seats.appointed_by': { label: 'Seat Appointed By', type: 'string' },
    'meeting_body_seats.is_vacant': { label: 'Seat Is Vacant', type: 'boolean' },
    'meeting_body_seats.number': { label: 'Seat Number', type: 'number' },
    'meeting_body_seats.requirements': {
        label: 'Seat Requirements',
        narrative: true,
        type: 'string',
    },
    'meeting_body_seats.title': { label: 'Seat Title', type: 'string' },
    'meeting_body_seats.type': {
        label: 'Seat Type',
        type: 'string',
        valueLabels: seatTypeValueLabels,
    },
};
export const campaignJoinDimensions = {
    'seat_campaigns.name': { label: 'Campaign', type: 'string' },
    'seat_campaigns.status': {
        label: 'Campaign Status',
        type: 'string',
        valueLabels: seatCampaignStatusValueLabels,
    },
    'seat_campaigns.total_open_seats': { label: 'Campaign Total Open Seats', type: 'number' },
};
export const campaignJoinTimeDimensions = {
    'seat_campaigns.end_date': { label: 'Campaign End Date', type: 'date' },
    'seat_campaigns.start_date': { label: 'Campaign Start Date', type: 'date' },
    'seat_campaigns.submission_deadline': { label: 'Campaign Submission Deadline', type: 'date' },
};
export const departmentJoinDimensions = {
    'departments.is_active': { label: 'Department Is Active', type: 'boolean' },
    'departments.name': { label: 'Department', link: departmentLink, type: 'string' },
};
export const meetingJoinDimensions = {
    'meetings.status': {
        label: 'Meeting Status',
        type: 'string',
        valueLabels: meetingStatusValueLabels,
    },
    'meetings.title': { label: 'Meeting Title', link: meetingLink, type: 'string' },
};
export const meetingJoinTimeDimensions = {
    'meetings.date': { label: 'Meeting Date', type: 'date' },
};
export const userJoinDimensions = {
    'users.display_name': { label: 'Staff Contact', link: userLink, type: 'string' },
    'users.email': { label: 'Staff Email', type: 'string' },
};
